import { toast } from "react-toastify";
import { getApiBaseUrl } from "../utils/apiBaseUrl";
import { AllAddressesData } from "./GetAllAddressesAsync";

export interface SearchAddressData {
  id: number;
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  addressType: string | null;
  isCustom: boolean;
  pinCode: string;
  pbdpPinCode: string | null;
  blockCode: string;
  addressCode: string;
  latitude: string;
  longitude: string;
  digiPin: string | null;
  userId: number;
  addressTypeId: number;
  createdDate: string | null;
  updatedDate: string | null;
  status: boolean;
  stateId: number;
  isPrivate: boolean;
  isFavourite: boolean;
  isClipped: boolean | null;
  clippedAt: string | null;
  isDeleteRequestSubmitted: boolean;
  isError: boolean | null;
  statusCode: number;
}

export interface SearchAddressesResponse {
  totalRecords: number;
  pageNumber: number;
  pageSize: number;
  data: AllAddressesData[];
}

/**
 * Search addresses.
 *
 * @param searchText Search text
 * @param pageNumber Current page number
 * @param pageSize Number of records per page
 * @param token JWT token
 * @returns Search results
 */
export async function SearchAddressesAsync(
  searchText: string,
  pageNumber: number,
  pageSize: number,
  token: string
): Promise<SearchAddressesResponse | null> {
  try {
    const baseUrl = await getApiBaseUrl();

    const response = await fetch(
      `${baseUrl}/api/Admin/SearchAddressesAsync?searchText=${encodeURIComponent(
        searchText
      )}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to search addresses. Status: ${response.status}`);
    }

    const data: SearchAddressesResponse = await response.json();
    return data;
  } catch (error) {
    console.error("Error searching addresses:", error);
    toast.error("Failed to search addresses.");
    return null;
  }
}